<template>
  <div>
    <!-- <div class="text-xs-center mt-4 mb-3" v-if="campaignLoading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else class="mb-2" style="display: flex; justify-content: end; flex-wrap: wrap">
      <v-btn
        v-for="(item, index) in campaignList"
        @click="chooseCampaign(item)"
        :outline="selectCampaign.name != item.name"
        :color="selectCampaign.name == item.name ? 'primary' : 'grey'"
        :key="`campaign-${index}`"
        >{{ item.name }}</v-btn
      >
    </div> -->
    <v-layout row wrap justify-end>
      <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;Export&nbsp;
      </v-btn>
    </v-layout>
    <div class="mb-2">
      <date-filter
        @changeDate="onChangeDate"
        :defaultFilter="'last_7_days'"
        v-model="selectedDate"
      ></date-filter>
    </div>
    <div class="mb-2" style="display: flex; flex-wrap: nowrap; overflow: auto">
      <v-btn
        small
        :outline="selectStatus != ''"
        :color="selectStatus == '' ? 'primary' : 'grey'"
        @click="selectStatus = ''"
        style="width: 100px"
        >ทั้งหมด</v-btn
      >
      <v-btn
        small
        :outline="selectStatus != 'จัดส่งแล้ว'"
        :color="selectStatus == 'จัดส่งแล้ว' ? 'primary' : 'grey'"
        @click="selectStatus = 'จัดส่งแล้ว'"
        style="width: 100px"
        >จัดส่งแล้ว</v-btn
      >
      <v-btn small outline color="grey" @click="selectStatus = ''" style="width: 100px"
        >ยกเลิก</v-btn
      >
    </div>
    <v-layout row wrap>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <input v-model="filter.name" class="form-control" placeholder="ค้นหา" type="text" />
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <multiselect
            v-model="filter.status"
            :options="[]"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            placeholder="สถานะ"
          ></multiselect>
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <multiselect
            v-model="filter.role"
            :options="[]"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            placeholder="Role"
          ></multiselect>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-content-end justify-end>
      <v-pagination
        :total-visible="6"
        v-model="pageNumber"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </v-layout>
    <div class="text-xs-center mt-4 mb-5" v-if="loading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="items && items.length > 0">
        <div class="card-outline mb-5" v-for="(item, index) in items" :key="index">
          <RewardItem v-model="items[index]" :key="'item_' + index"></RewardItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { getDate } from 'date-fns'
import RewardItem from './RewardItem.vue'
import XLSX from 'xlsx'

export default {
  components: {
    Multiselect,
    DatePickerWithoutButton,
    exportxlsx,
    DateFilter,
    RewardItem
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },

    selectCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  data() {
    return {
      selectStatus: '',
      campaignList: [],
      // selectCampaign: null,
      filter: {
        name: '',
        role: '',
        status: '',
        dateFrom: '',
        dateTo: ''
      },
      pageNumber: 1,
      loading: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      campaignLoading: false,
      limit: 10,
      offset: 0,
      items: [],
      total: 0,
      pagetmp: 1,
      rewardIds: [],
      approveLoading: false,
      approveAllLoading: false,
      shippingOptions: [],
      exportloading: false
    }
  },
  mounted() {
    // this.getEnabledCampagin()
    this.getData()
  },
  methods: {
    exportxlsx() {
      this.$store.dispatch('loading')
      this.exportloading = true
      let data = {
        pageid: this.selectedBot.pageid,
        // campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
        limit: 999,
        offset: 0
      }

      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }
      api.TOAECOUPONGetShippingReward(data, (err, response) => {
        this.exportloading = false
        this.$store.dispatch('loading')
        if (response.responsecode == 200) {
          let json = response.data
          let reward = []

          json.forEach((e1) => {
            e1.productdetails.forEach((e2) => {
              let cont_coupon = 0
              let temp_conpon = {}
              if (e2.name && e2.name.match('E-Coupon') && e1.ecoupon && e1.ecoupon[cont_coupon]) {
                temp_conpon = e1.ecoupon[cont_coupon]
                cont_coupon++
              }
              if (e1.ecoupon && e1.ecoupon.length) {
                let id_case = e2.id
                var barcodeList = e1.ecoupon.find((obj) => {
                  return obj.id == id_case
                })
                if (barcodeList) {
                  barcodeList = barcodeList.data
                  barcodeList = barcodeList.map((x) => {
                    return x.barcode
                  })
                  barcodeList = barcodeList.join(', ')
                }
              }
              reward.push({
                Date: moment(e1.timestamp).format('DD/MM/YYYY'),
                Time: moment(e1.timestamp).format('HH:mm'),
                'Order Number': e1.id,
                ชื่อสมาชิก: `${e1.first_name} ${e1.last_name}`,
                // รหัสร้านค้า: '',
                // ชื่อร้านค้า: '',
                // Area: '',
                'Total per Order': e1.total_points,
                ชื่อรางวัล: e2.name,
                'จำนวนของรางวัลที่แลก/ชิ้น': e2.quantity,
                'จำนวน แต้มทั้งหมด': e1.original_score,
                'จำนวน แต้มที่แลก/ชิ้น': e2.points / e2.quantity,
                'จำนวน แต้มที่แลกทั้งหมด': e1.total_points,
                'จำนวน แต้มคงเหลือ': e1.original_score - e1.total_points,
                'มูลค่าของรางวัล/ชิ้น/บาท': '',
                'มูลค่ารวมของรางวัล/บาท': '',
                'Status Order': e1.shipping_status,
                'เลขที่ Barcode Tesco Lotus': barcodeList ? barcodeList : '',
                Shipping: e1.shipping_type,
                'Tracking No.': e1.tracking_no,
                Remark: e1.remarks,
                ชื่อไลน์: e1.linename,
                ชื่อสมาชิก: `${e1.first_name} ${e1.last_name}`,
                ชื่อผู้รับ: `${e1.first_name} ${e1.last_name}`,
                Address:
                  e1.address +
                  ' ' +
                  e1.sub_district +
                  ' ' +
                  e1.district +
                  ' ' +
                  e1.province +
                  ' ' +
                  e1.post_code +
                  ' , เบอร์โทรศัพท์ ' +
                  e1.phone_number
              })
            })
          })

          const wb = XLSX.utils.book_new()
          const dataWS = XLSX.utils.json_to_sheet(reward)
          XLSX.utils.book_append_sheet(wb, dataWS, 'sheet1')

          XLSX.writeFile(wb, 'shipping' + '.xlsx')
        }
      })
    },
    onChangeDate() {
      this.filter = {
        name: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.getData(false, false, 'date')
    },
    getEnabledCampagin() {
      this.campaignLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }

      api.TOAECOUPONgetAllCampaign(payload, (err, result) => {
        if (result.responsecode == 200) {
          this.campaignLoading = false
          this.campaignList =
            result.data.length > 0 ? result.data.filter((f) => f.type == 'collect') : []
          if (this.campaignList && this.campaignList.length > 0) {
            this.selectCampaign = this.campaignList[0]
            this.getData()
          }
        }
      })
    },
    getData() {
      return new Promise((resolve) => {
        this.loading = true
        let data = {
          pageid: this.selectedBot.pageid,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
          start_date: this.selectedDate.start,
          end_date: this.selectedDate.end,
          limit: this.limit,
          offset: this.offset
        }

        for (const key in this.filter) {
          if (this.filter[key]) {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }

        api.TOAECOUPONGetShippingReward(data, (err, response) => {
          resolve()
          this.loading = false
          if (response.responsecode == 200) {
            this.items = response.data
            this.total = response.total
          }
        })
      })
    },
    chooseCampaign(campaign) {
      this.selectCampaign = campaign
      this.offset = 0
      this.getData()
    },
    changePage(val) {
      if (this.pagetmp != val) {
        this.pagetmp = val
        this.offset = this.pageNumber * this.limit - this.limit
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.getData()
      }
    },
    chooseOrder(item, value) {
      const index = this.rewardIds.find((f) => f.id == item.id)
      if (index != -1) {
        if (value) {
          this.rewardIds.push(item.id)
        } else {
          this.rewardIds.splice(index, 1)
        }
      } else {
        this.rewardIds.push(item.id)
      }
    },
    getShipping() {
      let data = { pageid: this.selectedBot.pageid }
      api.getAllShipingCharge(data, (error, response) => {
        if (error) console.error(error)

        let result = Object.keys(response.shippinglist).map(function (key) {
          return { name: key, ...response.shippinglist[key] }
        })

        this.shippingOptions = result
      })
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
.isprimay {
  background-color: #ff706b !important;
  color: white !important;
}
.text-gray {
  color: #969595;
}
.text-cus {
  color: #ff706b !important;
}
.card-outline {
  border: 1px solid #ff706b;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/SendingReward/main.vue